<template>
	<div class="grid-flex-container pa-4">
		<v-container class="py-6" fluid>
			<v-row>
				<div style="flex-grow: 1">
					<v-text-field
						v-if="canView"
						v-model="search"
						class="py-0 my-0 mb-2 mr-2"
						append-icon="mdi-magnify"
						label="Search"
						single-line
						hide-details
					/>
				</div>
				<v-btn v-if="canAdd" color="primary" @click="onAdd()">
					<v-icon> mdi-plus</v-icon>
					&nbsp;&nbsp;Add
				</v-btn>
			</v-row>
		</v-container>
		<div class="generic-grid-container">
			<v-data-table
				v-if="canView"
				dense
				:items="activities"
				:headers="headers"
				:search.sync="search"
				:loading="loading"
				disable-pagination
				fixed-header
				hide-default-footer
				loading-text="Loading..."
			>
				<template v-slot:[`item.IsVisible`]="{ item }">
					<span v-if="item.IsVisible === true">Is visible</span>
					<span v-else>Is not visible</span>
				</template>
				<template v-slot:[`item.actions`]="{ item }">
					<v-btn
						v-if="canEdit"
						fab
						small
						icon
						elevation="1"
						class="action-btn"
						@click.stop="editForm(item)"
					>
						<v-icon color="primary" small>mdi-pencil</v-icon>
					</v-btn>
					<v-btn
						v-if="canDelete"
						fab
						small
						icon
						elevation="1"
						class="action-btn"
						@click.stop="deleteForm(item)"
					>
						<v-icon color="error" small>mdi-delete</v-icon>
					</v-btn>
					<v-btn
						v-if="canClone"
						fab
						small
						icon
						elevation="1"
						class="action-btn"
						@click.stop="cloneActivity(item)"
					>
						<v-icon small>mdi-content-duplicate</v-icon>
					</v-btn>
				</template>
			</v-data-table>
		</div>
	</div>
</template>
<script>
import { Permissions } from '../../../enums/permissionsEnum';
import permissionsMixin from '../../../mixins/permissionsMixin';
import { mapGetters } from 'vuex';
import { ActivityBuilderActions } from '../../../store/actions';
import { ActivityActions } from '../../../store/actions';
import { ActivityBuilderGetters } from '../../../store/getters';
import ConfirmDialog from '@/components/core/dialogs/confirmDialog';
import CloneDialog from '@/components/core/dialogs/cloneDialog';
export default {
	name: 'ActivityBuilder',
	mixins: [permissionsMixin],
	components: {},
	data() {
		return {
			search: '',
			headers: [
				{ text: 'Name', value: 'Name' },
				{ text: 'Entity', value: 'EntityName' },
				{ text: 'Status', value: 'IsVisible' },
				{ text: '', value: 'actions', sortable: false, align: 'end' },
			],
		};
	},
	computed: {
		...mapGetters({
			activities: [ActivityBuilderGetters.ACTIVITIES],
			loading: [ActivityBuilderGetters.LOADING],
		}),
		canView() {
			return this.hasPermissions([
				Permissions.Tools.ActivityBuilder.View,
			]);
		},
		canAdd() {
			return this.hasPermissions([Permissions.Tools.ActivityBuilder.Add]);
		},
		canEdit() {
			return this.hasPermissions([
				Permissions.Tools.ActivityBuilder.Edit,
			]);
		},
		canDelete() {
			return this.hasPermissions([
				Permissions.Tools.ActivityBuilder.Delete,
			]);
		},
		canClone() {
			return this.hasPermissions([
				Permissions.Tools.ActivityBuilder.Clone,
			]);
		},
	},
	mounted() {
		this.$store.dispatch(ActivityBuilderActions.LOAD_ACTIVITIES);
	},
	destroyed() {
		this.$store.dispatch(ActivityBuilderActions.CLEAR);
	},
	methods: {
		onAdd() {
			this.$router.push({ name: 'AddActivity' });
		},
		editForm(item) {
			this.$router.push({
				name: 'EditActivity',
				params: { id: item.Id },
			});
		},
		deleteForm(item) {
			ConfirmDialog({
				message: 'Are you sure you want to delete this activity?',
			}).then((isDelete) => {
				if (!isDelete) return;
				this.$store
					.dispatch(ActivityBuilderActions.DELETE_ACTIVITY, item.Id)
					.then((resp) => {
						if (resp == true)
							this.$store.dispatch(
								ActivityActions.LOAD_ACTIVITIES
							);
					});
			});
		},
		cloneActivity(item) {
			CloneDialog({
				message: item.Name,
			}).then((resp) => {
				if (!resp.success) return;
				let payload = {
					SourceActivityId: item.Id,
					DestinationActivityName: resp.name,
				};
				this.$store
					.dispatch(ActivityBuilderActions.CLONE, payload)
					.then((resp) => {
						if (resp == true)
							this.$store.dispatch(
								ActivityActions.LOAD_ACTIVITIES
							);
					});
			});
		},
	},
};
</script>
